import { NgModule } from '@angular/core';
import { DateFormatPipe } from './date-format/date-format';
import { TruncatePipe } from './truncate/truncate';
import { ThumbnailPipe } from './thumbnail/thumbnail';
import { TitlePipe } from './title/title';
import { DatePipe } from '@angular/common';
import { ThousandPipe } from './thousand/thousand';
@NgModule({
	declarations: [DateFormatPipe,
    TruncatePipe,
    ThumbnailPipe,
    TitlePipe,
    ThousandPipe],
	imports: [],
	exports: [DateFormatPipe,
    TruncatePipe,
    ThumbnailPipe,
    TitlePipe,
    ThousandPipe],
    providers:[DatePipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts